import loading from './fullLoading.vue'
const loadingBox = {};

loadingBox.install = (Vue) => {
  // 单例
  let singleInstance;
  loading.newInstance = properties => {
    const props = properties || {};
    // new过了
    const Instance = new Vue({
      data: props,
      render (h) {
        return h(loading, {
          props: props
        });
      }
    });

    const component = Instance.$mount();
    document.body.appendChild(component.$el);
    const insvue = Instance.$children[0]; //拿到vue实例
    return {
      // 添加实例方法，以供全局调用
      show(obj,fn){
        insvue.show(obj,fn)
      },
      close(){
        insvue.close()
      },
    }
  }
  singleInstance = singleInstance||loading.newInstance()
  // ImgComponent.newInstance(properties) 可以传入props对象

  Vue.prototype.$fullLoading = singleInstance //实体直接挂载在vue下面
};
export default loadingBox;
